import ApiResourceManager from '../ApiResourceManager';

export default class ServiceProviderNotificationSettingsManager extends ApiResourceManager {
  /**
   * Which channels a partner may notify on (super admin only). Scoped to the
   * on-behalf-of service provider, so the Partners page can edit any partner —
   * same contract as ServiceProviderFeatureFlagsManager.
   */
  get = (serviceProviderId = undefined) =>
    this.request({
      method: 'GET',
      url: '/service-provider-notification-settings',
      ...(serviceProviderId && { headers: { 'x-on-behalf-of-service-provider': serviceProviderId } }),
    });

  update = (settings, serviceProviderId = undefined) =>
    this.request({
      method: 'PUT',
      url: '/service-provider-notification-settings',
      data: settings,
      ...(serviceProviderId && { headers: { 'x-on-behalf-of-service-provider': serviceProviderId } }),
    });
}
